import { Box, Checkbox, Divider, FormControl, Grid, InputBase, InputLabel, ListItemText, ListSubheader, MenuItem, OutlinedInput, Select } from '@mui/material'
import { DateRangePicker, SingleInputDateRangeField } from '@mui/x-date-pickers-pro'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { shortcuts } from '../../utils/Dates'
import { LoadingButton } from '@mui/lab'
import { GlobalContext } from '../../GlobalContext'
import { gettingEmployees, gettingSmartgroups } from '../../utils/Filter'
import { Context } from '../table/timecard/Context'

import SearchIcon from '@mui/icons-material/Search';

// Common
const FilterTimecard = () => {
    const { t } = useTranslation('filter')
    const { t: tUtils } = useTranslation('utils')

    const { 
        handlerAlert
    } = useContext(GlobalContext)

    const {
        range1,
        setRange1,
        smartgroups,
        setSmartgroups,
        smartgroup,
        setSmartgroup,
        filter1,
        setFilter1,
        employees,
        setEmployees,
        employee,
        setEmployee,
        filter2,
        setFilter2,
        loadingGettingSmartgroups,
        setLoadingGettingSmartgroups,
        loadingGettingEmployees,
        setLoadingGettingEmployees,
        loadingGettingTimecard,
        loadingGettingSchedule,
        loadingGettingOpenPeriod,
        ready, setReady,
        renders, setRenders,
        searching,
    } = useContext(Context)

    useEffect(() => {
        gettingSmartgroups(
            setLoadingGettingSmartgroups,
            setSmartgroups,
            setSmartgroup,
            'timecard',
            handlerAlert
        )
    }, [
        handlerAlert,
        setLoadingGettingSmartgroups, 
        setSmartgroup, 
        setSmartgroups,
    ])

    useEffect(() => {
        if(smartgroup.length !== 0 && !loadingGettingSmartgroups){
            gettingEmployees(
                setLoadingGettingEmployees,
                smartgroups,
                smartgroup,
                setEmployees,
                setEmployee,
                'timecard',
                renders,
                range1,
                handlerAlert,
            )    

            setReady(true)
        }else{
            setEmployees([])
            setEmployee([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [smartgroup, smartgroups, setEmployee, setEmployees, setLoadingGettingEmployees, handlerAlert, setReady, loadingGettingSmartgroups, renders])

    
    useEffect(() => {
        if(
            employee.length !== 0 &&
            smartgroup.length !== 0 &&
            ready && renders === 0 &&
            !loadingGettingSmartgroups &&
            !loadingGettingEmployees
        ){
            searching()
            setReady(false)
            setRenders(1)
        }
    }, [
        employee, 
        smartgroup, 
        ready,
        renders,
        searching,
        setReady,
        setRenders,
        loadingGettingSmartgroups,
        loadingGettingEmployees
    ])

    return (
        <>
            <Box
                sx={{
                    display: 'flex', 
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 2,
                    p: 1.5,
                    borderBottom: theme => `1px solid ${theme.palette.divider}`, 
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <DateRangePicker
                            label={t('filter_timecard.range_of_days')}
                            slots={{ field: SingleInputDateRangeField }}
                            slotProps={{
                                shortcuts: {
                                    items: shortcuts(tUtils),
                                },
                            }}
                            format={JSON.parse(sessionStorage.getItem('config')).date_format}
                            calendars={1}
                            fullwith
                            onAccept={(value) => { setRange1(value) }}
                            value={range1}
                            sx={{
                                width: '100%'
                            }}
                        />
                    </Grid>
                    
                    <Grid item xs={3}>
                        <FormControl fullWidth required error={smartgroup.length === 0 && !loadingGettingSmartgroups}>    
                            <InputLabel id="lsg">{t('filter_timecard.smartgroups')}</InputLabel>

                            <Select
                                labelId="lsg"
                                id="sg"
                                multiple
                                value={smartgroup.map(sg => sg.name)}
                                input={<OutlinedInput label={t('filter_timecard.smartgroups')} />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={{
                                    style:{ 
                                        maxHeight: '400px',
                                    }
                                }}
                            >
                                { (smartgroups.length !== 0 && !loadingGettingSmartgroups) &&
                                    <Box>
                                        <Checkbox 
                                            sx={{ml: 2}} 
                                            checked={
                                                filter1 === '' ?
                                                    smartgroups.filter(s => smartgroup.map(s => s.name).includes(s.name)).length === smartgroups.length
                                                    :
                                                    smartgroups.filter(sg => sg.name.toLowerCase().includes(filter1.toLocaleLowerCase())).every(sg => smartgroup.map(s => s.name).includes(sg.name))
                                            } 
                                            indeterminate={
                                                filter1 === '' ?
                                                    smartgroups.filter(s => smartgroup.map(s => s.name).includes(s.name)).length !== smartgroups.length && smartgroup.length > 0
                                                    :
                                                    !smartgroups.filter(sg => sg.name.toLowerCase().includes(filter1.toLocaleLowerCase())).every(sg => smartgroup.map(s => s.name).includes(sg.name)) && 
                                                    !smartgroups.filter(sg => sg.name.toLowerCase().includes(filter1.toLocaleLowerCase())).every(sg => !smartgroup.map(s => s.name).includes(sg.name)) &&
                                                    smartgroups.filter(sg => sg.name.toLowerCase().includes(filter1.toLocaleLowerCase())).length !== 0 
                                            }
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSmartgroup(smartgroups.filter(sg => sg.name.toLowerCase().includes(filter1.toLocaleLowerCase())).map(sg => sg))
                                                }else{
                                                    setSmartgroup(smartgroup.filter(s => !smartgroups.filter(sg => sg.name.toLowerCase().includes(filter1.toLocaleLowerCase())).map(sg => sg.name).includes(s.name)))
                                                }
                                            }}
                                        />

                                        <InputBase 
                                            sx={{
                                                width: 'calc(100% - 80px)',
                                                ml: 1,
                                                mb: 1.5
                                            }}
                                            placeholder='search...'
                                            endAdornment={<SearchIcon sx={{mr: 1}} />}
                                            value={filter1}
                                            onChange={(e) => setFilter1(e.target.value)}
                                        />

                                        <Divider />

                                        { smartgroups.filter(sg => sg.name.toLowerCase().includes(filter1.toLocaleLowerCase())).map((sg) => (
                                            <MenuItem 
                                                key={sg.id} 
                                                onClick={() => {
                                                    if (smartgroup.filter(s => s.name === sg.name).length > 0) {
                                                        setSmartgroup(smartgroup.filter(s => s.name !== sg.name))
                                                    } else {
                                                        setSmartgroup([...smartgroup, sg])
                                                    }
                                                }}
                                            >
                                                <Checkbox checked={smartgroup.filter(s => s.name === sg.name).length > 0} />
                                                <ListItemText primary={sg.name} />
                                            </MenuItem>
                                        ))}
                                    </Box>
                                }
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth error={employee.length === 0 && !loadingGettingEmployees}>
                            <InputLabel id="lsg">{t('filter_timecard.employees')}</InputLabel>

                            <Select
                                labelId="lsg"
                                id="sg"
                                multiple
                                value={employee.map(e => e.full_name)}
                                input={<OutlinedInput label={t('filter_timecard.employees')} />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={{
                                    style:{ 
                                        maxHeight: '400px',
                                    }
                                }}
                            >
                                { (employees.length !== 0 && !loadingGettingEmployees) &&
                                    <Box>
                                        <InputBase 
                                            sx={{
                                                pl: 2,
                                                pr: 2,
                                                width: '100%',
                                                ml: 1,
                                                mb: 1.5
                                            }}
                                            placeholder='search...'
                                            endAdornment={<SearchIcon sx={{mr: 1}} />}
                                            value={filter2}
                                            onChange={(e) => setFilter2(e.target.value)}
                                        />

                                        <Divider />

                                        { smartgroups.filter(sg => smartgroup.map(sg => sg.name).includes(sg.name)).map(sg => 
                                            <Box key={sg.id}>
                                                <ListSubheader>{sg.name}</ListSubheader>

                                                { employees.filter(e => e.smartgroup === sg.name).filter(e => e.full_name.toLowerCase().includes(filter2.toLocaleLowerCase())).sort((a, b) => a?.full_name.localeCompare(b?.full_name)).map((e) => (
                                                    <MenuItem 
                                                        key={`${e.id}-${e.smartgroup}`} value={e.full_name}
                                                        onClick={() => {
                                                            if(employee.find(emp => emp.id === e.id)){
                                                                setEmployee([])
                                                            }else{
                                                                setEmployee(employees.filter(emp => emp.id === e.id))
                                                            }
                                                        }}
                                                        selected={employee.filter(emp => emp.full_name === e.full_name).length > 0}
                                                        sx={{
                                                            p: 1.5
                                                        }}
                                                    >
                                                        <ListItemText primary={e.full_name} />
                                                    </MenuItem>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                }
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={2}>
                        <LoadingButton
                            sx={{position: 'absolute', right: '15px', height: '56px'}} 
                            loading={
                                loadingGettingSmartgroups ||
                                loadingGettingEmployees ||
                                loadingGettingTimecard ||
                                loadingGettingSchedule ||
                                loadingGettingOpenPeriod
                            }
                            variant='contained'
                            disabled={
                                !range1[0]?.isValid() ||
                                !range1[1]?.isValid() ||
                                range1[0]?.isAfter(range1[1]) ||
                                smartgroup.length === 0 ||
                                employee.length === 0
                            }
                            onClick={searching}
                            disableElevation
                        >
                            {t('filter_timecard.search.title')}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export { 
    FilterTimecard
}